/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PostV2UsersPasswordResetsMutationRequest, PostV2UsersPasswordResetsMutationResponse } from "../../../types/PostV2UsersPasswordResets.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPostV2UsersPasswordResetsUrlClient() {
  const res = { method: 'POST', url: `/v2/users/password_resets` as const }
  return res
}

/**
 * @description Request a password reset for a user account. A secure token will be sent to the user's email.
 * **Key differences from V1:**
 * - V1 generates a random password and sends it via email
 * - V2 sends a secure reset token; user sets their own password via PATCH endpoint
 * **Security:**
 * - Returns success for both valid and invalid emails (prevents email enumeration)
 * - Token expires after 2 hours
 * - Token is URL-safe base64 (43 characters, 256 bits of entropy)
 * @summary Request password reset (V2)
 * {@link /v2/users/password_resets}
 */
export async function postV2UsersPasswordResetsClient(data: PostV2UsersPasswordResetsMutationRequest, config: Partial<RequestConfig<PostV2UsersPasswordResetsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostV2UsersPasswordResetsMutationResponse, ResponseErrorConfig<Error>, PostV2UsersPasswordResetsMutationRequest>({ method : "POST", url : getPostV2UsersPasswordResetsUrlClient().url.toString(), data : requestData, ... requestConfig })
  return res
}